import React from 'react';
import '../style/BreakingNews.css';

const BreakingNews = () => {
  const news = "Volvo EX90 India Debut Nears as Flagship EV Revealed Ahead of October 12 Launch";

  return (
    <div className="ticker-container">
      <div className="ticker-label">LATEST NEWS</div>
      <div className="ticker-window">
        <div className="ticker-track">
          {/* Unit 1 */}
          <div className="ticker-unit">
            <img src="https://cdn-icons-png.flaticon.com/512/744/744465.png" alt="car" className="moving-car" />
            <span className="ticker-text">{news}</span>
          </div>
          {/* Unit 2 (Required for seamless loop) */}
          <div className="ticker-unit">
            <img src="https://cdn-icons-png.flaticon.com/512/744/744465.png" alt="car" className="moving-car" />
            <span className="ticker-text">{news}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreakingNews;